import React from 'react';
import bookcover from './bookcover';
import useFirestore from './useFirestore';

// import { motion } from 'framer-motion';

const ImageGrid = ({ setSelectedImg }) => {
  const { docs } = useFirestore('images');
  
  // var loginButton;
  // if (loggedIn) {
  //   loginButton = <LogoutButton />;
  // } else {
  //   loginButton = <LoginButton />;
  // }
  
  // return (
  //   <nav>
  //     <Home />
  //     {loginButton}
  //   </nav>
  // );
  return (
    <div className="img-grid">
      {docs && docs.map(doc => (
        <div className="img-wrap" key={doc.id} 
         
          onClick={() => setSelectedImg(doc.url)}
        >
          <img className="img_display" src={doc.url} alt="uploaded pic"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          />
         
        </div>
      ))}
    </div>
  )
}
              {/* <div className='banner'>
              <h1> Banner</h1>
              {
            (()=>{
              if(doc.name==='banner'){
                return(
                 
            <img src={doc.url} alt="uploaded pic"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          />)}})}
          </div>  
          <div className='webbanner'>
                  <h1>Web Banner</h1>
                 {(()=>{
              if(doc.name==='webbanner'){ return(
                 
                  <img src={doc.url} alt="uploaded pic"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 1 }}
                />
                )}})}</div>  
                 <div className='bookcover'>
            <h1>Book Cover</h1>

            {(()=>{
              if(doc.name==='bookcover'){ return(
                 
            <img src={doc.url} alt="uploaded pic"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          />)}})}</div>  
                <div className='logo'>
                  <h1>Logos</h1>
                  {(()=>{
              if(doc.name==='logo'){ return(
                  
                  <img src={doc.url} alt="uploaded pic"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 1 }}
                />)}})}</div>  
                */}
           
         {/* {doc.name==='webbanner'  &&
            <div className='webbanner'>
            <h1>Web Banner</h1>
            <img src={doc.url} alt="uploaded pic"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          /></div>  
          }
        
        {doc.name==='bookcover' &&
            <div className='bookcover'>
            <h1>Book Cover</h1>
            <img src={doc.url} alt="uploaded pic"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          /></div>  
          }
         {doc.name==='logo' &&
            <div className='logo'>
            <h1>Logos</h1>
            <img src={doc.url} alt="uploaded pic"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          /></div>  
          } */}
         

export default ImageGrid;